
export default {
  name: 'RectangleBgCardBlock',
  props: {
    blockOptions: {
      type: Object
    }
  }
}
